import componentExample from './_component-example';
import componentExampleScript from './_component-example-script';
import componentExampleIframe from './_component-example-iframe';

export { componentExample, componentExampleScript, componentExampleIframe };
